import { React, useState, useEffect } from 'react';
import Nav from './nav';
import './tabs.css';
import Card from './card';
import Transcript from './bulletin';
import Receipt from './receipt.js';
import Attestation from './attestation.js';
import AccessCredentials from './accessCredentials.js';
import Diploma from './diploma.js';
import DiplomeSans from './diplomesans.js';
import UNDDiplomaTemplate from './templates/UND/UNDDiplomaTemplate.js';
import UNDMasterTemplate from './templates/UND/UNDMasterTemplate.js';
import AquiDeDroitTemplate from './aquidedroit.js';
import AttestationGrade from './attestationGrade.js';
import CertificatScolariteTemplate from './certificatscolarite.js';
import AttestationValidationTemplate from './attestationvalidation.js';
import ProcesVerbal from './procesVerbal.js';
import RapportSoutenance from './rapportSoutenance.js';
import app from './firebase.js';

function Tab() {
  const [activeTab, setActiveTab] = useState('Tab1');

  useEffect(() => {
    switch (activeTab) {
      case 'Tab1':
        document.title = 'UNCR - Carte Etudiant';
        break;
      case 'Tab2':
        document.title = 'UNCR - Bulletin Academique';
        break;
      case 'Tab3':
        document.title = 'UNCR - Reçu de Paiement';
        break;
      case 'Tab4':
        document.title = 'UNCR - Inscription doctorale';
        break;
      case 'Tab5':
        document.title = 'UNCR - Coordonnées d\'accès';
        break;
      case 'Tab6':
        document.title = 'UNCR - Upload Documents';
        break;
      case 'Tab7':
        document.title = 'UNCR - Recherche de Document';
        break;
      case 'Tab8':
        document.title = 'UNCR - Diplôme';
        break;
      case 'Tab9':
        document.title = 'UNCR - Diplôme Sans';
        break;
      case 'Tab10':
        document.title = 'UNCR - UND Diplôme';
        break;
      case 'Tab11':
        document.title = 'UNCR - UND Master';
        break;
      case 'Tab12':
        document.title = 'UNCR - A QUI DE DROIT';
        break;
      case 'Tab13':
        document.title = 'UNCR - ATTESTATION DE GRADE';
        break;
      case 'Tab14':
        document.title = 'UNCR - CERTIFICAT DE SCOLARITE';
        break;
      case 'Tab15':
        document.title = 'UNCR - ATTESTATION DE VALIDATION DU SEMINAIRE';
        break;
      case 'Tab16':
        document.title = 'UNCR - Procès Verbal';
        break;
      case 'Tab17':
        document.title = 'UNCR - Rapport de soutenance';
        break;
      default:
        document.title = 'UNCR - Admin';
    }
  }, [activeTab]);

  return (
    <div className="ISTAM">
      <div className="tab-page">
        <Nav/>
        <br/>
        <br/>
        <div className="tab-container">
          <div className="tabs">
            <button
              className={activeTab === 'Tab1' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab1')}
            >
              Carte Etudiant
            </button>
            <button
              className={activeTab === 'Tab2' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab2')}
            >
              Bulletin Academique
            </button>
            <button
              className={activeTab === 'Tab3' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab3')}
            >
              Reçu de Paiement
            </button>
            <button
              className={activeTab === 'Tab4' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab4')}
            >
              Inscription doctorale
            </button>
            <button
              className={activeTab === 'Tab5' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab5')}
            >
              Coordonnées d'accès
            </button>
            <button
              className={activeTab === 'Tab8' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab8')}
            >
              Diplôme
            </button>
            <button
              className={activeTab === 'Tab9' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab9')}
            >
              Diplôme Sans
            </button>
            <button
              className={activeTab === 'Tab10' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab10')}
            >
              UND Diplôme
            </button>
            <button
              className={activeTab === 'Tab11' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab11')}
            >
              UND Master
            </button>
            <button
              className={activeTab === 'Tab12' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab12')}
            >
              A QUI DE DROIT
            </button>
            <button
              className={activeTab === 'Tab13' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab13')}
            >
              ATTESTATION DE GRADE
            </button>
            <button
              className={activeTab === 'Tab14' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab14')}
            >
              CERTIFICAT DE SCOLARITE
            </button>
            <button
              className={activeTab === 'Tab15' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab15')}
            >
              ATTESTATION DE VALIDATION
            </button>
            <button
              className={activeTab === 'Tab16' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab16')}
            >
              Procès Verbal
            </button>
            <button
              className={activeTab === 'Tab17' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab17')}
            >
              Rapport de soutenance
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'Tab1' && <div className="content"><Card/></div>}
            {activeTab === 'Tab2' && <div className="content"><Transcript/></div>}
            {activeTab === 'Tab3' && <div className="content"><Receipt/></div>}
            {activeTab === 'Tab4' && <div className="content"><Attestation/></div>}
            {activeTab === 'Tab5' && <div className="content"><AccessCredentials/></div>}
            {activeTab === 'Tab8' && <div className="content"><Diploma/></div>}
            {activeTab === 'Tab9' && <div className="content"><DiplomeSans/></div>}
            {activeTab === 'Tab10' && <div className="content"><UNDDiplomaTemplate app={app}/></div>}
            {activeTab === 'Tab11' && <div className="content"><UNDMasterTemplate app={app}/></div>}
            {activeTab === 'Tab12' && <div className="content"><AquiDeDroitTemplate app={app}/></div>}
            {activeTab === 'Tab13' && <div className="content"><AttestationGrade app={app}/></div>}
            {activeTab === 'Tab14' && <div className="content"><CertificatScolariteTemplate app={app}/></div>}
            {activeTab === 'Tab15' && <div className="content"><AttestationValidationTemplate app={app}/></div>}
            {activeTab === 'Tab16' && <div className="content"><ProcesVerbal app={app}/></div>}
            {activeTab === 'Tab17' && <div className="content"><RapportSoutenance app={app}/></div>}
          </div>
        </div>
        <footer>G.A.P 2025 © All Rights Reserved.</footer>
      </div>
    </div>
  );
}

export default Tab;
